import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAdd, faTrashCan, faCloudArrowUp,
    faDownload, faTags, faGear, faFillDrip,
    faBinoculars, faCheck, faSave, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { supabase } from './supabase';

library.add(faAdd, faTrashCan, faCloudArrowUp,
    faDownload, faTags, faGear,
    faFillDrip, faBinoculars, faCheck, faSave, faEye, faEyeSlash);

supabase.auth.getSession().finally(async() => {
    const app = createApp(App);
    app.component("font-awesome-icon", FontAwesomeIcon);
    app.use(store);
    app.use(router);

  await router.isReady()

    // Detects refresh/reload
    const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined
    const isReload =
        (nav && nav.type === 'reload') ||
        ((performance as any).navigation && (performance as any).navigation.type === 1)

    // Redirect to '/'
    if (isReload && router.currentRoute.value.path !== '/') {
        await router.replace('/')
    }

    app.mount("#app");
});
